var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeormediaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Navbar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 572 280.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        fill: #231f20;\n      }\n\n      .st3 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 169.1,
    y1: -12479.9,
    x2: 31.2,
    y2: -12511.6,
    gradientTransform: "translate(0 -12362) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fde42e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcdd2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#faca2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f7ac2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f3822a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ee4c29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea2228"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 160.2,
    y1: -12420.1,
    x2: 89.2,
    y2: -12579.1,
    gradientTransform: "translate(0 -12362) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fde42e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f9c02c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f27c2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ee4b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#eb2d28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ea2228"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 182.9,
    y1: -12464.4,
    x2: 100.7,
    y2: -12621,
    gradientTransform: "translate(0 -12362) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fde42e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fcdd2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f7ac2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f3812a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ef5f29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ed4429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eb3128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ea2528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea2228"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 211.5,
    y1: -12496.3,
    x2: 118.6,
    y2: -12643.6,
    gradientTransform: "translate(0 -12362) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fde42e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fac82d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f3822a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ea2228"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94.3,2.8s22.2,21.7-27.3,85.8l-29.7,44.3s-46.5,60.7,5.2,108.8c0,0,35.4,27.1,55.5,24.9,0,0-21.3-18.2-29.6-50.9,0-.5-.3-.8-.4-1.3-1.6-10.1-2.8-24.8,21.7-63.9l38.3-56.4s15.5-20.6-3.4-45.6L94.3,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.6,48.4s11.2,34.4-9,65c0,0-15.7,23.4-31.6,42.8,0,0-17.2,18.9-15.1,58.1,0,0,0-8.6,40-46.9,0,0,26.2-25.4,32.7-40.9,0,0,19.8-32.7-17-78.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.3,84.9s9,35.1-13.1,64.3c0,0-17.2,22.4-34.3,40.7,0,0-18.4,17.8-18.7,57,0,0,.5-8.6,42.9-44.2,0,0,27.8-23.7,35.2-38.7,0,0,21.8-31.4-12-79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M191.5,121.6s6.2,35.7-18.2,63c0,0-18.9,21-37.4,37.9,0,0-19.7,16.3-23.2,55.3,0,0,1.2-8.5,46.3-40.7,0,0,29.6-21.4,38.2-35.8,0,0,24.2-29.6-5.7-79.7h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M249.1,140.6V48.9h17.7v82.2h33.2l-1,9.6h-49.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M365.7,140.6h-52.6V48.9h50.7l-1,9.3-32,.5v29.9l30.1.5-.7,8.4-29.4.7v32.7l35.6.7-.7,9.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M464.8,94.5c0,7.2-1,13.9-2.6,19.6-1.9,5.7-4.5,10.8-8.4,15.1-3.6,4.1-8.4,7.4-13.9,9.6-5.5,2.2-11.9,3.3-19.1,3.3s-13.9-1.2-19.4-3.3c-5.5-2.2-9.8-5.5-13.1-9.6-3.3-4.1-6-9.1-7.6-15.1s-2.4-12.4-2.4-19.6.7-13.6,2.4-19.4,4.3-10.5,7.6-14.6c3.6-4.1,7.9-7.2,13.4-9.3,5.5-2.2,11.7-3.3,19.1-3.3s13.9,1.2,19.4,3.3c5.5,2.2,10,5.3,13.6,9.3,3.6,4.1,6.5,8.8,8.1,14.6,1.9,5.7,2.6,12.2,2.6,19.4,0,0,.3,0,.3,0ZM446.2,94.5c0-5.5-.5-10.5-1.4-15.1s-2.4-8.1-4.5-11.2c-2.2-3.1-4.8-5.5-7.9-7.2s-6.9-2.4-11.2-2.4-7.4.5-10.8,1.2-6,1.9-7.9,3.6c-1.9,1.4-3.3,4.8-4.3,10s-1.4,12.2-1.4,21,.5,10.5,1.2,15.1c.7,4.6,2.2,8.4,4.1,11.7s4.3,5.7,7.4,7.4,6.9,2.6,11.5,2.6,8.6-.5,11.7-1.2c3.1-1,5.7-1.9,7.6-3.6,1-.7,1.9-1.9,2.6-4.1s1.4-4.5,1.9-7.4c.5-2.9,1-6.2,1.2-9.6,0-3.6.2-7.2.2-11h0v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M506.7,102.9h-6v37.8h-17.7V49.1c3.6-.2,7.6-.5,12.2-.7,4.5,0,8.8-.2,12.9-.2,10.5,0,18.6,1.9,24.1,6,5.5,4.1,8.1,10.3,8.1,19.1s-.5,7.2-1.4,10c-1,2.9-2.2,5.3-3.6,7.4s-3.3,3.8-5.3,5.3-4.1,2.6-6.2,3.6c2.6,4.8,5,9.1,7.4,13.4,2.4,4.1,4.8,7.9,7.2,11s4.8,5.5,7.2,7.4,5,2.6,7.9,2.6h.5v6c-1.4.5-3.1,1-4.8,1.2s-3.8.5-6.2.5-6.2-.2-8.6-1c-2.4-.5-4.8-1.9-7.2-3.8-2.4-1.9-4.8-5-7.2-8.8s-5.3-9.1-8.6-15.5l-4.8-9.6h0ZM503.8,93.8c2.4,0,4.8-.2,7.2-1s4.1-1.4,5.5-2.4c.7-.5,1.4-1,1.9-1.7.7-.7,1.2-1.7,1.9-2.9.5-1.2,1-2.6,1.2-4.5s.5-4.1.5-6.9-.2-5.7-1-7.9-1.7-3.8-3.1-5-3.1-2.2-5.3-2.9c-2.2-.5-4.3-1-7.2-1s-1.4,0-2.4,0-1.7,0-2.4.2v35.8h3.1v.2h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.2,231l-5.5-46.2-23.6,46.2h-4.1l-24.6-46.2-4.4,46.2h-7.9l6.8-60.9h12.7l22.9,42.8,21.9-42.8h12.3l7.2,60.9h-13.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M385.6,231h-39.7v-60.6h38.3l-.7,6.2h-24.3v19.8h22.9l-.7,5.8h-22.2v22.2h26.7c0,.3-.7,6.5-.7,6.5h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M396.9,171.1c1.4,0,3.1,0,4.8-.3,1.7,0,3.8,0,5.8-.3h12.3c5.5,0,10.3.7,14.7,1.7,4.4,1,8.2,2.7,11.3,5.1,3.1,2.4,5.5,5.1,7.2,8.9,1.7,3.8,2.7,7.9,2.7,13s-.7,9.6-2.1,13.7-3.4,7.5-6.5,10.6c-3.1,2.7-6.8,5.1-11.3,6.8-4.8,1.7-10.3,2.4-16.8,2.4s-3.8,0-5.8,0h-11.3c-1.7,0-3.4,0-4.8-.3v-59.5l-.3-1.7h0ZM410.6,225.2h6.5c4.1,0,7.2,0,9.9-.7,2.7-.7,5.1-1.4,6.8-2.4,1-.7,2.1-1.7,2.7-2.7s1.7-2.4,2.4-4.1,1.4-3.8,1.7-6.5c.3-2.7.7-5.8.7-9.6s-.7-8.6-2.1-11.6c-1.4-3.1-3.1-5.5-5.1-7.2-2.1-1.7-4.8-3.1-7.5-3.8s-6.2-1-9.6-1-1,0-1.7,0h-5.1v48.6l.3,1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M483.1,231h-13.3v-60.6h13.3v60.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M539.9,231l-7.9-20.5h-25l-7.9,20.5h-8.6l26-59.9,13-2.1,24.3,61.9h-14.4.5ZM530,205l-9.9-26-10.3,26h20.2,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeormediaLogo);
export default __webpack_public_path__ + "static/media/LeormediaLogo.75604774fe4172aedcccf4ead2511b9e.svg";
export { ForwardRef as ReactComponent };